import { Tag, Tooltip } from 'antd';
import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { AssignmentStatus, AssignmentType, NumberOfSubmission, SubmissionOverviewStatus, UnixTimestamp } from '@module/assignment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ParticipatedAssignmentTypeTag = function ParticipatedAssignmentTypeTag(_ref) {
  var item = _ref.item,
      labels = _ref.labels;
  return /*#__PURE__*/_jsx(Tag, {
    color: "blue",
    children: item.type.id === AssignmentType.Practice ? labels.practice : labels.examination
  });
};
export var ParticipatedAssignmentTiming = function ParticipatedAssignmentTiming(_ref2) {
  var item = _ref2.item,
      now = _ref2.now,
      labels = _ref2.labels,
      renderCountdown = _ref2.renderCountdown;
  var deadline = UnixTimestamp.parseMilliseconds(item.endTime);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!!item.duration && item.duration > 0 && /*#__PURE__*/_jsx(Tooltip, {
      title: labels.durationLabel,
      trigger: ['hover', 'focus'],
      children: /*#__PURE__*/_jsxs("span", {
        tabIndex: 0,
        "aria-label": "".concat(labels.durationLabel, ": ").concat(labels.duration(item.duration)),
        children: [/*#__PURE__*/_jsx(ClockCircleOutlined, {}), " ", labels.duration(item.duration)]
      })
    }), item.type.id === AssignmentType.Examination && deadline !== null && item.canOpen(now) && renderCountdown(deadline)]
  });
};
export var ParticipatedAssignmentProgress = function ParticipatedAssignmentProgress(_ref3) {
  var _item$report$status, _item$report$totalSub;

  var item = _ref3.item,
      labels = _ref3.labels;
  if (((_item$report$status = item.report.status) === null || _item$report$status === void 0 ? void 0 : _item$report$status.id) === SubmissionOverviewStatus.banned.value) return /*#__PURE__*/_jsx("span", {
    children: labels.accessRestricted
  });
  var count = (_item$report$totalSub = item.report.totalSubmittedSubmission) !== null && _item$report$totalSub !== void 0 ? _item$report$totalSub : 0;
  var limit = item.numberOfSubmission;
  if (limit === NumberOfSubmission.unlimited) return /*#__PURE__*/_jsx("span", {
    children: labels.unlimitedAttempts
  });
  return /*#__PURE__*/_jsx("span", {
    className: "submission-progress",
    children: limit && limit > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [labels.submissions, ' ', /*#__PURE__*/_jsxs("b", {
        children: [count, "/", limit]
      }), /*#__PURE__*/_jsx("span", {
        className: "progress-track",
        "aria-hidden": "true",
        children: /*#__PURE__*/_jsx("span", {
          style: {
            width: "".concat(Math.min(100, count / limit * 100), "%")
          }
        })
      })]
    }) : labels.submittedCount(count)
  });
};
export var ParticipatedAssignmentAvailability = function ParticipatedAssignmentAvailability(_ref4) {
  var _item$report$status2, _item$report$status3;

  var item = _ref4.item,
      now = _ref4.now,
      labels = _ref4.labels,
      formatTime = _ref4.formatTime;
  var banned = ((_item$report$status2 = item.report.status) === null || _item$report$status2 === void 0 ? void 0 : _item$report$status2.id) === SubmissionOverviewStatus.banned.value;
  var end = UnixTimestamp.parseMilliseconds(item.endTime);

  if (((_item$report$status3 = item.report.status) === null || _item$report$status3 === void 0 ? void 0 : _item$report$status3.id) === SubmissionOverviewStatus.finished.value) {
    var submittedAt = UnixTimestamp.parseMilliseconds(item.report.submitTime);
    if (submittedAt === null) return null;
    return /*#__PURE__*/_jsxs("span", {
      className: "deadline",
      children: [/*#__PURE__*/_jsx(CalendarOutlined, {}), " ", labels.due, " ", formatTime(submittedAt)]
    });
  }

  if (!banned) {
    if (item.systemStatus && item.systemStatus.id !== AssignmentStatus.ACTIVE) return /*#__PURE__*/_jsx("span", {
      children: labels.unavailable
    });
    var start = UnixTimestamp.parseMilliseconds(item.startTime);
    if (!item.isOverdue(now) && start !== null && start > now) return /*#__PURE__*/_jsx("span", {
      children: labels.opensAt(formatTime(item.startTime))
    });
  }

  return /*#__PURE__*/_jsxs("span", {
    className: "deadline",
    children: [/*#__PURE__*/_jsx(CalendarOutlined, {}), " ", end !== null && "".concat(labels.due, " "), formatTime(item.endTime)]
  });
};
export var participatedAssignmentTeacher = function participatedAssignmentTeacher(item, labels) {
  return item.assigner ? "".concat(item.assigner.firstName, " ").concat(item.assigner.lastName).trim() : labels.unknownTeacher;
};